import React from 'react';

const CardBrand = ({ brands, selectCreditCardBrand }) => (
  <div className="area-cartoes flex">
    <div className="area-bandeiras">
      <ul className="lista-cartoes radio-input">
        {brands.map((card, index) => (
          <li key={index}>
            <input
              type="radio"
              id={`card${index}`}
              name="c1"
              checked={card.selected}
              onChange={() => selectCreditCardBrand(index)}
            />
            <label htmlFor={`card${index}`}>
              <img src={`/assets/images/home/home/cards/v2/${card.brand_name}.svg`} alt={`${card.brand_name} logo`} />
              <span className="cartao-titulo">{card.parcels > 1 ? `Até ${card.parcels}x` : 'À vista'}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default CardBrand;



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/CreditCard/CardBrand.jsx